import { MailOutlined, ReloadOutlined } from '@ant-design/icons';

export const MailReloadIcon = () => (
    <span style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20
    }}>
        <ReloadOutlined style={{ fontSize: 23, position: 'absolute' }} />
        <MailOutlined style={{ fontSize: 9, zIndex: 1 }} />
    </span>
);